class Button extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="button">
          Button
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-button" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">All typography options</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="button-demo">
  <div class="button-demo__row">
    <h5>Sizes</h5>
    <button class="small">Small Button</button>
    <button class="regular">Regular Button</button>
    <button class="large">Large Button</button>
  </div>
  <div class="button-demo__row">
    <h5>Themes</h5>
    <button class="info">Info Theme</button>
    <button class="success">Success Theme</button>
    <button class="warning">Warning Theme</button>
    <button class="error">Error Theme</button>
    <button class="clear">Clear Theme</button>
  </div>
  <div class="button-demo__row">
    <h5>Inverted Themes</h5>
    <button class="info inverted">Info Inverted</button>
    <button class="success inverted">Success Inverted</button>
    <button class="warning inverted">Warning Inverted</button>
    <button class="error inverted">Error Inverted</button>
    <span class="whitebg">
      <button class="clear inverted">Clear Inverted</button>
    </span>
  </div>
  <div class="button-demo__row">
    <h5>Other</h5>
    <button class="disabled">Disabled Button</button>
    <button class="theme">Theme Hover</button>
    <button class="spinner">Spinner</button>
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.button-demo {
  @include grid();

  &__row {
    @include column(12);

    background: $charcoal-grey;
    color: $white;

    .whitebg {
      background: $white;
      display: inline-block;
      height: 45px;
      margin-top: 15px;
    }
  }

  button {
    margin-right: 20px;
    margin-top: 20px;
    display: flex;
    float: left;
  }

  .small {
    @include button($size: small);
  }

  .regular {
    @include button($size: regular);
  }

  .large {
    @include button($size: large);
  }

  .info {
    @include button();

    &.inverted {
      @include button($inverted: true);
    }
  }

  .success {
    @include button($theme: success);

    &.inverted {
      @include button($theme: success, $inverted: true);
    }
  }

  .warning {
    @include button($theme: warning);

    &.inverted {
      @include button($theme: warning, $inverted: true);
    }

  }

  .error {
    @include button($theme: error);

    &.inverted {
      @include button($theme: error, $inverted: true);
    }
  }

  .clear {
    @include button($theme: clear);

    &.inverted {
      @include button($theme: clear, $inverted: true);
      margin-top: 2px;
      margin-left: 20px;
    }
  }

  .disabled {
    @include button($disabled: true);
  }

  .theme {
    @include button($theme: clear, $hover-theme: info);
  }

  .spinner {
    @include button();
    @include spinner();
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="button-demo">
                    <div className="button-demo__row">
                      <h5>Sizes</h5>
                      <button className="small">Small Button</button>
                      <button className="regular">Regular Button</button>
                      <button className="large">Large Button</button>
                    </div>
                    <div className="button-demo__row">
                      <h5>Themes</h5>
                      <button className="info">Info Theme</button>
                      <button className="success">Success Theme</button>
                      <button className="warning">Warning Theme</button>
                      <button className="error">Error Theme</button>
                      <button className="clear">Clear Theme</button>
                    </div>
                    <div className="button-demo__row">
                      <h5>Inverted Themes</h5>
                      <button className="info inverted">Info Inverted</button>
                      <button className="success inverted">Success Inverted</button>
                      <button className="warning inverted">Warning Inverted</button>
                      <button className="error inverted">Error Inverted</button>
                      <span className="whitebg">
                        <button className="clear inverted">Clear Inverted</button>
                      </span>
                    </div>
                    <div className="button-demo__row">
                      <h5>Other</h5>
                      <button className="disabled">Disabled Button</button>
                      <button className="theme">Theme Hover</button>
                      <button className="spinner">Spinner</button>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
